import { Navigate, Route, Routes } from "react-router-dom";

import ROUTES from "@app/common/routes";

import Coaching from "./Coaching";

const CoachingRoutes = () => {
  return (
    <Routes>
      <Route path=":section" element={<Coaching />} />
      <Route
        path="*"
        element={<Navigate to={ROUTES.COACHING_DEFAULT_SECTION} replace />}
      />
    </Routes>
  );
};

export default CoachingRoutes;
